import { configureStore, combineReducers } from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk';

import theme from './modules/theme'
import user from './modules/user'
import reprtForm from './modules/user'

const reducer = combineReducers({
  theme,
  user,
  reprtForm
})

const store = configureStore({
  reducer,
  middleware: [thunkMiddleware]
})

export default store